import { any } from 'ramda';

export const isCurrentLocation = (location: string): boolean => {
  return window.location.pathname === location;
};

export const isCurrentLocationOneOf = (locations: string[]): boolean => {
  return any((location: string) => isCurrentLocation(location))(locations);
};
